import { KeysConvertType } from 'common/types/KeysConvertType'
import { camelKeys } from 'js-convert-case'

export class KeysConvert implements KeysConvertType {
  constructor() {}

  ToLowerCase<T extends object>(json: T) {
    return camelKeys(json, { recursive: true, recursiveInArray: true }) as T
  }

  ConvertAllToLower<T extends object>(input: T[]): T[] {
    const output: T[] = []
    for (const entry of input) {
      output.push(this.ToLowerCase(entry))
    }

    return output
  }
}
